import { useIsMobile, getResponsiveImageUrl } from 'helpers/ui';
import { FallbackImage } from '@rcw/ui';
import './aboutUs.scss';
import { goToCustomUrl } from 'controls/utils';
import { CTAButton } from 'components/atoms/Button/Button';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

export default function AboutUsSection({ data }) {
  const isMobile = useIsMobile(850);
  const aboutUsData = data;

  return (
    <div className='aboutUsContainer' style={{ display: 'flex', flexDirection: aboutUsData.alignment === 'left' ? 'row-reverse' : 'row' }}>
      <FallbackImage
        src={getResponsiveImageUrl(aboutUsData.imageUrl, aboutUsData.mobileImageUrl, isMobile)}
        fallbackSrc={aboutUsData.imageUrl}
        alt={DOMPurify.sanitize(aboutUsData.topTitle, { ALLOWED_TAGS: [] })}
        fetchPriority='high'
      />
      <div className='aboutUsContainer_data px-8 m-auto'>
        <div className='aboutUsContainer_topTitle proxima-nova-bold' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(aboutUsData.topTitle) }} />
        <div className='aboutUsContainer_title proxima-nova-bold' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(aboutUsData.title) }} />
        <div className='aboutUsContainer_body' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(aboutUsData.body) }} />
        <div className='flex'>
          <CTAButton ctaText={aboutUsData.ctaText} onClick={() => goToCustomUrl(aboutUsData.ctaUrl)} />
        </div>
      </div>
    </div>
  );
}

AboutUsSection.propTypes = {
  data: PropTypes.shape({
    enabled: PropTypes.bool,
    order: PropTypes.number,
    imageUrl: PropTypes.string,
    mobileImageUrl: PropTypes.string,
    topTitle: PropTypes.string,
    title: PropTypes.string,
    body: PropTypes.string,
    ctaText: PropTypes.string,
    ctaUrl: PropTypes.string,
    alignment: PropTypes.string,
  }),
};
